import React from 'react';
import TableLink from '../../components/TableLink';
import {
  prettyPhone,
  required,
  phoneNumberVal,
  emailVal,
} from '../../helpers/utils';

// The shared "value" field holds either a phone number or an email address;
// only phone values should be reformatted on blur (emails contain "@").
const prettyContactValue = (value: any): string =>
  typeof value === 'string' && value.includes('@') ? value : prettyPhone(value);

const contactValueValidate = (
  value: any,
  allValues: any,
): string | undefined => {
  const requiredError = required(value);
  if (requiredError) return requiredError;
  if (allValues?.info_type === 'email') return emailVal(value);
  if (allValues?.info_type === 'phone') return phoneNumberVal(value);
  return undefined;
};

// TODO: REMINDER: If something breaks, I removed the seemingly obsolete "Email" and "Phone" entries from  CONTACT_FIELDS.
export const CONTACT_FIELDS = [
  {
    name: 'first_name',
    label: 'First Name',
    validate: required,
  },
  {
    name: 'last_name',
    label: 'Last Name',
  },
  {
    name: 'title',
    label: 'Title',
  },
  {
    name: 'company',
    label: 'Company',
  },
  {
    name: 'notes',
    label: 'Notes',
    multiline: true,
  },
];

// Store and edit share the same fields; editing just locks the info type.
const contactInfoFields = ({ editing }: { editing: boolean }) => [
  {
    name: 'info_type',
    label: 'Select Type',
    component: 'select',
    disabled: editing,
    options: [
      { label: 'Phone', value: 'phone' },
      { label: 'Email', value: 'email' },
    ],
    validate: required,
  },
  {
    name: 'type',
    label: 'Contact Type',
    component: 'select',
    // The server rejects details without a type; surface that in the form
    // instead of failing after submit.
    validate: required,
    sortOptions: false,
    options: [
      { label: 'Work', value: 'work' },
      { label: 'Home', value: 'home' },
      { label: 'Personal', value: 'personal' },
      { label: 'Fax', value: 'fax' },
      { label: 'Other', value: 'other' },
    ],
  },
  {
    name: 'value',
    label: 'Phone # or Email Address',
    validate: contactValueValidate,
    transformOnBlur: prettyContactValue,
  },
];

export const STORE_CONTACT_INFO = contactInfoFields({ editing: false });

export const EDIT_CONTACT_INFO = contactInfoFields({ editing: true });

export const CONTACT_COLUMNS = [
  {
    Header: 'Name',
    accessor: 'full_name',
    // full_name is "First Last", but the list is ordered by last name server
    // side. Sort on last name so the displayed order matches what the API sends.
    sortType: (a, b) =>
      `${a.original.last_name} ${a.original.first_name}`.localeCompare(
        `${b.original.last_name} ${b.original.first_name}`,
      ),
    Cell: ({ cell: { value: name }, row: { original } }) => {
      return <TableLink to={`/contacts/edit/${original.id}`}>{name}</TableLink>;
    },
  },
  {
    Header: 'Email',
    accessor: 'emails',
    Cell: ({ row: { original } }) =>
      original.emails.length ? original.emails[0].value : 'no emails',
  },
  {
    Header: 'Phone',
    accessor: 'phones',
    Cell: ({ row: { original } }) =>
      original.phones.length
        ? prettyPhone(original.phones[0].value)
        : 'no phone',
  },
  {
    Header: 'Company',
    accessor: 'company',
  },
];

export const PROJECT_MEMB_COLUMNS = [
  {
    Header: 'Project Description',
    accessor: 'description',
    Cell: ({ cell: { value: name }, row: { original } }) => {
      return <TableLink to={`/projects/edit/${original.id}`}>{name}</TableLink>;
    },
  },
  {
    Header: 'Created At',
    accessor: 'created_at',
  },
];
